import useTranslator from "../hooks/useTranslator";
import { Tabs, TextField } from "./design";
import "./BillingDetailsFields.css";

const numericOnlyOnKeyDown = (e) => {
  const allowed = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Enter",
  ];
  if (!/[0-9]/.test(e.key) && !allowed.includes(e.key)) e.preventDefault();
};

/**
 * Invoice details form: Private / Business tabs and the address fields.
 * Used by "Buy credits" and the workspace "Edit billing information" popup.
 * `headExtra` sits on the right of the tabs (e.g. an "Edit billing details" button).
 */
const BillingDetailsFields = ({
  billingType,
  onBillingTypeChange,
  billingData,
  onFieldChange,
  headExtra,
}) => {
  const { _t } = useTranslator();
  const postalCode = billingData.postal_code ?? "";
  const postalCodeValid =
    postalCode.trim() === "" || postalCode.trim().length === 5;

  const field = (key, label, placeholder, props = {}) => (
    <TextField
      id={`billing-${key}`}
      label={label}
      placeholder={placeholder}
      value={billingData[key] ?? ""}
      onChange={(e) => onFieldChange(key, e.target.value)}
      {...props}
    />
  );

  return (
    <div className="billing-fields">
      <div className="billing-fields__head">
        <Tabs
          size="sm"
          value={billingType}
          onChange={onBillingTypeChange}
          items={[
            { value: "private", label: _t("private") },
            { value: "business", label: _t("business") },
          ]}
        />
        {headExtra}
      </div>
      <div className="billing-fields__grid">
        {billingType === "business" ? (
          <>
            {field("company_name", _t("companyName"), _t("enterCompanyName"))}
            {field("tax_id", _t("taxId"), _t("enterTaxId"))}
          </>
        ) : (
          field("full_name", _t("fullName"), _t("enterFullName"), {
            className: "billing-fields__wide",
          })
        )}
        {field("country", _t("country"), _t("enterCountry"))}
        {field("city", _t("city"), _t("enterCity"))}
        {field("address", _t("address"), _t("enterAddress"))}
        {field("postal_code", _t("postalCode"), _t("enterPostalCode"), {
          inputMode: "numeric",
          maxLength: 5,
          onKeyDown: numericOnlyOnKeyDown,
          error: !postalCodeValid && _t("postalCodeMustBe5Digits"),
        })}
      </div>
    </div>
  );
};

export default BillingDetailsFields;
